














































import {
  CampaignReportData,
  CampaignReportItem,
} from "@/models/CampaignReport";
import Site from "@/models/site";
import { Component, Vue, Prop } from "vue-property-decorator";
import ApexCharts from "vue-apexcharts";
import moment from "moment";
import Campaign from "@/models/campaign";
import DefinitionValues from "@/views/Definitions/Components/DefinitionValues.vue";
import DefinitionValue from "@/models/definitionValue";
import ClientCampaignReportDetailTable from "./ClientCampaignReportDetailTable.vue";

@Component({
  components: { ApexCharts, ClientCampaignReportDetailTable },
})
export default class ClientCampaignReportDetail extends Vue {
  @Prop() inputData!: CampaignReportData;
  @Prop() site!: Site;

  dailyClicks: { name: string; type: string; data: number[] }[] = [];
  dailyPrints: { name: string; type: string; data: number[] }[] = [];

  webStats: CampaignReportItem[] = [];
  lineItemsIds: (string | undefined)[] = [];
  webLineItemsIds: (string | undefined)[] = [];
  nlLineItemsIds: (string | undefined)[] = [];

  created(): void {
    this.lineItemsIds = (this.inputData.campaign as Campaign).lineItems
      .filter((l) => l.siteId === this.site.id)
      .map((l) => l.id);

    this.webLineItemsIds = this.filterLineItems("web");
    this.nlLineItemsIds = this.filterLineItems("newsletter");

    // TODO: Obtener las estádisticas filtradas por ambiente web o newsletter;
    // this.webStats = this.getStats("web");

    this.dailyClicks = this.getDailyData("click");
    this.dailyPrints = this.getDailyData("print");
  }

  getOptions(type: string) {
    return {
      title: {
        text: this.$t(`reports.campaign.${type}`).toString(),
      },
      xaxis: {
        title: { text: this.$t("reports.campaign.dates") },
        min: moment(this.inputData.meta.report.start).toDate().getTime(),
        type: "datetime",
        tickAmount: 6,
      },
      yaxis: [
        {
          title: {
            text: this.$t(`reports.campaign.${type}_amount`).toString(),
          },
        },
      ],
      dataLabels: {
        enabled: false,
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
    };
  }

  getCategories(): Date[] {
    const start = moment(this.inputData.meta.report.start);
    const end = moment(this.inputData.meta.report.end);
    const days = end.diff(start, "days");
    const categories = [];

    categories.push(start.toDate());
    for (let i = 0; i < days; i++) {
      categories.push(start.add(1, "d").toDate());
    }

    return categories;
  }

  getDailyData(metric: string): { name: string; type: string; data: any }[] {
    const dates = this.getCategories();
    const data: { date: number; value: number; formatedDate: string }[] = [];
    dates.forEach((d) => {
      const dt = moment(d);
      data.push({
        date: d.getTime(),
        formatedDate: dt.format("YYYY-MM-DD"),
        value: 0,
      });
    });

    this.inputData.dailyData.forEach((d) => {
      const date = moment(`${d.year}-${d.month}-${d.day}`).format("YYYY-MM-DD");

      const index = data.findIndex((dt) => {
        return dt.formatedDate === date;
      });

      if (this.lineItemsIds.includes(d.lineItemId) && index !== -1) {
        if (metric === "click") {
          data[index].value += d.clicks;
        } else {
          data[index].value += d.prints;
        }
      }
    });

    return [
      {
        name: this.$t("reports.campaign.clicks").toString(),
        type: "column",
        data: data.map((d) => [d.date, d.value]),
      },
    ];
  }

  filterLineItems(environment: string): (string | undefined)[] {
    const lineItems: (string | undefined)[] = [];
    let webDefinitions: (string | undefined)[] = [];

    this.inputData.definitions?.forEach((definition) => {
      if (definition.value === "environment") {
        let def: DefinitionValue[] = [];
        if (environment === "web") {
          def = definition.values.filter((d) => d.value !== "newsletter");
        } else {
          def = definition.values.filter((d) => d.value === "newsletter");
        }
        webDefinitions = def.map((d) => d.id);
      }
    });

    (this.inputData.campaign as Campaign).lineItems.forEach((lineItem) => {
      lineItem.definitionValueIds.forEach((def) => {
        const includes = webDefinitions.includes(def);
        if (includes && lineItem.siteId === this.site.id) {
          lineItems.push(lineItem.id);
        }
      });
    });

    return lineItems;
  }

  getStats(environment: string): CampaignReportItem[] {
    const lineItems =
      environment === "web" ? this.webLineItemsIds : this.nlLineItemsIds;

    const data = this.inputData.dailyData.filter((d) => {
      return lineItems.includes(d.lineItemId);
    });

    return data;
  }
}
